import type React from "react";

interface EmailReceiverIntegrationFormProps {
  namespace: string;
}

export default function EmailReceiverIntegrationForm(
  props: EmailReceiverIntegrationFormProps,
): React.ReactElement {
  return (
    <div className="text-gray-600 text-sm">
      <p>
        Email receiver integration will automatically process email attachments.
        Configuration options will be available after creation.
      </p>
    </div>
  );
}
